export const STEPS = {
	SELECT_PLAN: 'SELECT_PLAN',
	BILLING: 'BILLING',
	PAYMENT: 'PAYMENT'
};
